import * as React from "react"
const SvgAngry = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={80}
    height={80}
    viewBox="0 0 21.167 21.167"
    {...props}
  >
    <ellipse
      id="backgroung-svg"
      cx={10.606}
      cy={10.602}
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.327}
      rx={9.898}
      ry={9.892}
    />
    <circle id="backgroung-svg3" cx={13.525} cy={8.277} r={1.455} />
    <path
       id="backgroung-svg2"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.323}
      d="M15.33 5.378c-.948.333-1.99.843-2.531 2.532"
    />
    <circle id="backgroung-svg3" cx={-7.749} cy={8.267} r={1.455} transform="scale(-1 1)" />
    <path
       id="backgroung-svg2"
      fill="none"
      stroke="#000"
      strokeLinecap="round"
      strokeWidth={1.323}
      d="M6.015 5.368c.947.333 1.99.843 2.531 2.532M6.396 14.958c2.024-3.708 6.542-3.694 8.248-.051"
    />
  </svg>
)
export default SvgAngry;
